import request from '@/utils/request'

export async function getGenres(params) {
  const res = await request({
    url: '/genres',      
    method: 'get',
    params
  })
  return res.data.data
}